import axiosInstance from "./axiosInstance";
import axios from "axios";

export const adminLogin = async (email, password) => {
  const response = await axiosInstance.post("/admin-login", {
    email,
    password,
  });
  return response.data;
};

export const sendContactForm = async (
  email,
  fullName,
  contact,
  message
) => {
  const response = await axios.post(
    process.env.REACT_APP_EMAIL_SERVICE_URL,
    {
      email,
      fullName,
      contact,
      message,
      website: "", // honeypot
      submittedAt: Date.now(),
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};

export const getAllContactForm = async () => {
  const response = await axiosInstance.get("/get-all-contacts");
  return response.data;
};

export const deleteContact = async (id) => {
  const response = await axiosInstance.delete(`/delete-contact/${id}`);
  return response.data;
};
